import React from "react";
import ShippingOne from "../components/ShippingOne";
import BreadcrumbThree from "../components/BreadcrumbThree";
import CancellationAndRefund from "../components/CancellationAndRefund";
import { Helmet } from "react-helmet-async";

const CancellationAndRefundPage = () => {
  return (
    <>

      <Helmet>
        <title> Cancellation and Refund | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>
      </Helmet>

      {/* Breadcrumb */}
      <BreadcrumbThree title={"Cancellation And Refund"} />

      {/* Account */}
      <CancellationAndRefund />

      {/* ShippingOne */}
      <ShippingOne />

    </>
  )
}

export default CancellationAndRefundPage